import type { SxProps } from '@mui/material';
import { CurrencyCodes } from '@onevesthq/ov-enums';
import { Box } from '@ovComponents/1-primative/box/box';
import type { TypographyPropsVariants } from '@ovComponents/1-primative/typography/typography';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { currencySymbol } from '@utils/currency';
import { formatMoneyValue } from '@utils/moneyFormatting';

type ValueSuperscriptedCentsProps = {
  value?: number;
  mainVariant: TypographyPropsVariants['variant'];
  centsVariant: TypographyPropsVariants['variant'];
  currency?: CurrencyCodes;
  color?: string;
  testId?: string;
  mainSx?: SxProps;
  centsSx?: SxProps;
};

export const ValueSuperscriptedCents = ({
  value,
  mainVariant,
  centsVariant,
  currency,
  color,
  testId = 'value-scripted-cents',
  mainSx,
  centsSx,
}: ValueSuperscriptedCentsProps) => {
  const formattedValue = formatMoneyValue(
    value,
    currencySymbol[currency ?? CurrencyCodes.CAD],
    undefined,
    false,
  );
  const [mainValue, centsValue] = formattedValue.split(
    formattedValue.includes('.') ? '.' : ',',
  );

  return (
    <Box display='flex' data-testid={testId}>
      <Typography
        variant={mainVariant}
        sx={{ fontVariant: 'tabular-nums', color, ...mainSx }}
      >
        {mainValue}
      </Typography>
      <Typography
        variant={centsVariant}
        sx={{ fontVariant: 'tabular-nums', color, ...centsSx }}
      >
        {formattedValue.includes('.') ? '.' : ','}
        {centsValue ?? '00'}
      </Typography>
    </Box>
  );
};
